import { Children } from "react";
import { x } from "@xstyled/styled-components";

export { ApplicationProcess } from "./ApplicationProcess";
export { Compensation } from "./Compensation";
export { Experience } from "./Experience";
export { Functions } from "./Functions";
export { JobInvolves } from "./JobInvolves";
export { LanguageRequirements } from "./LanguageRequirements";
export { Location } from "./Location";
export { Team, TeamUpsell } from "./Team";
export { Technologies } from "./Technologies";
export { Titles } from "./Titles";
export { WhoYouAre } from "./WhoYouAre";

export default function Sections({ children }: { children: React.ReactNode }) {
  return (
    <>
      {Children.map(children, (child, i) => {
        if (!child) return null;
        return (
          <>
            {i > 0 && <x.div h="1px" backgroundColor="beige-200" my="xxl" />}
            {child}
          </>
        );
      })}
    </>
  );
}
